import { Button, CircularProgress, Grid, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import { ErrorModal } from "../../../../components/modals/error-modal";
import MesfModal from "../../../../components/modals/modal.mesf";
import { Job } from "../models/Job";
import { RestartJob } from "../repositories/JobsRepository";

type Props = {
	jobSelected: Job | null;
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const ResetJob = ({ jobSelected, show, onHide }: Props) => {
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);

	const onSubmit = async () => {
		setIsLoading(true);
		RestartJob(jobSelected?.JobId ?? null)
			.then((res) => {
				if (res.ok) {
					onHide(true);
					setOpenSnackbar(true);
				} else {
					setError(res.message);
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<>
			<MesfModal
				title="RESET JOB"
				open={show}
				handleClose={() => onHide(false)}
				id="reset-job-modal"
			>
				<MesfModal.Content>
					Are you sure you want to reset? This action leaves the task in enable
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "16px 24px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="default"
								onClick={() => onHide(false)}
							>
								Disagree
							</Button>
						</Grid>
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								startIcon={isLoading && <CircularProgress size="1rem" />}
								onClick={() => onSubmit()}
								disabled={isLoading}
								variant="contained"
								color="primary"
							>
								Agree
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2500}
				onClose={() => setOpenSnackbar(false)}
			>
				<Alert severity="success" onClose={() => setOpenSnackbar(false)}>
					The job was reseted succesfully
				</Alert>
			</Snackbar>
		</>
	);
};
